window.addEventListener("load", function () {
  const translations = {
    nl: {
      addToCart: "Voeg toe",
      outOfStock: "Uitverkocht",
    },
    en: {
      addToCart: "Add to cart",
      outOfStock: "Out of stock",
    },
    fi: {
      addToCart: "Lisää ostoskoriin",
      outOfStock: "Loppuunmyyty",
    },
    fr: {
      addToCart: "Ajouter au panier",
      outOfStock: "Épuisé",
    },
    es: {
      addToCart: "Añadir al carrito",
      outOfStock: "Agotado",
    },
    da: { addToCart: "Læg i kurv", outOfStock: "Udsolgt", added: "Tilføjet!" },
    de: {
      addToCart: "In den Warenkorb",
      outOfStock: "Ausverkauft",
    },
    pl: {
      addToCart: "Dodaj do koszyka",
      outOfStock: "Wyprzedane",
    },
    no: {
      addToCart: "Legg i handlekurv",
      outOfStock: "Utsolgt",
    },
    sv: {
      addToCart: "Lägg i varukorg",
      outOfStock: "Slutsåld",
    },
  };

  const DEFAULT_LOCALE = "nl";
  const locale = (window.Shopify && Shopify.locale) || DEFAULT_LOCALE;
  const t = translations[locale] || translations[DEFAULT_LOCALE];

  function setState(btn, state) {
    btn.textContent = t[state];
  }

  function initButton(btn) {
    if (btn.dataset.opusInitialized) return; // prevent listener twice
    btn.dataset.opusInitialized = "true";

    if (
      btn.classList.contains("opus-stc-widget__btn--disabled") ||
      btn.disabled
    ) {
      setState(btn, "outOfStock");
    } else {
      setState(btn, "addToCart");
    }

    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      setState(btn, "");
      setTimeout(() => setState(btn, "addToCart"), 2000);
    });
  }

  const existingBtn = document.querySelector(".opus-stc-widget__btn");
  if (existingBtn) {
    initButton(existingBtn);
    return;
  }

  const observer = new MutationObserver(() => {
    const btn = document.querySelector(".opus-stc-widget__btn");
    if (btn) {
      initButton(btn);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // safety timeout: prevent observe fall into loop if atc button never show up
  setTimeout(() => observer.disconnect(), 15000);
});